import React from 'react';

export default function WorkloadIndicator({ current, max, label = "Arbeidsmengde" }) {
  const percentage = Math.min(Math.round((current / max) * 100), 100);
  
  const getStatusColor = (p) => {
    if (p < 50) return 'bg-green-500';
    if (p < 85) return 'bg-yellow-500';
    return 'bg-red-500';
  };

  const getStatusText = (p) => {
    if (p < 50) return 'God kapasitet';
    if (p < 85) return 'Begrenset kapasitet';
    return 'Fullbooket';
  };

  return (
    <div className="w-full space-y-1">
      <div className="flex justify-between text-xs font-medium text-slate-400">
        <span>{label}</span>
        <span className={percentage >= 100 ? 'text-red-400' : ''}>
          {current} / {max} saker
        </span>
      </div>
      <div className="h-1.5 w-full bg-slate-700 rounded-full overflow-hidden">
        <div 
          className={`h-full transition-all duration-500 ${getStatusColor(percentage)}`}
          style={{ width: `${percentage}%` }}
        />
      </div>
      <p className="text-[10px] text-slate-500 italic">
        {getStatusText(percentage)}
      </p>
    </div>
  );
}